// Delete's words (ADR-0096), one copy for every place a document is deleted or shown as deleted: the main window's
// document heading, a moved fields panel, the Deleted view and Export › Activity.

/**
 * Delete acts at once, with no question (owner, 2026-10-30): its way back is the Undo on the status bar's
 * "Deleted an Invoice · Undo", and this names that Undo's button (and tells it apart from other notices' ways back).
 */
export const DELETE_UNDO_TELEMETRY = 'document-delete-undo' as const;

/** "Deleted an Invoice", or "Deleted a document" for one with no type: the notice a Delete leaves. */
export const deletedNotice = (typeWithArticle: string | null) =>
  typeWithArticle ? `Deleted ${typeWithArticle}` : 'Deleted a document';

/** The engine's sentence for an automatic delete (DeletedDocument.reasonText), for one that came without it. */
export const AUTOMATIC_DELETE_SENTENCE =
  "Deleted automatically: looks like earlier pages that weren't documents.";
